import { IsConnectedResponse, WorkspaceIdRequest } from '../request-response';
import { ResourceName } from '../resource-name';

export const HubSpotGate = {
  resource: ResourceName.hubspot,
  actions: {
    isConnected: 'is-connected',
    getContactList: 'get-contact-list',
    getCompanyList: 'get-company-list',
  },
};

export type HubSpotGateActionTypes = {
  isConnected: {
    request: WorkspaceIdRequest;
    response: IsConnectedResponse;
  };
  getContactList: {
    request: WorkspaceIdRequest;
    response: any;
  };
  getCompanyList: {
    request: WorkspaceIdRequest;
    response: any;
  };
};
